import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackBannerShow, trackBannerClick } from './tracking';
import { NewbuildingBrokerConsultantBanner } from '../../components/NewbuildingBrokerConsultantBanner';
import {
  selectNewbuildingBrokerConsultantBannerUrl,
  selectNewbuildingBrokerConsultantBannerButtonText,
} from 'shared/selectors/newbuildingBrokerConsultantBanner';
import { selectJsonQuery } from 'shared/selectors/results';

export const NewbuildingBrokerConsultantBannerContainer: React.FC = () => {
  const url = useSelector(selectNewbuildingBrokerConsultantBannerUrl) as string;
  const buttonText = useSelector(selectNewbuildingBrokerConsultantBannerButtonText);

  const jsonQuery = useSelector(selectJsonQuery);

  const onShow = React.useCallback(() => {
    trackBannerShow(jsonQuery);
  }, [jsonQuery]);

  const onClick = React.useCallback(() => {
    trackBannerClick(jsonQuery);
  }, [jsonQuery]);

  return (
    <ActionAfterViewObserver callback={onShow} percentVisible={0.8} triggerOnce>
      <NewbuildingBrokerConsultantBanner url={url} buttonText={buttonText} onClick={onClick} />
    </ActionAfterViewObserver>
  );
};
